module.exports = __webpack_public_path__ + "static/media/cms.c64dfa3d.svg";